import { render, staticRenderFns } from "./PageSize.vue?vue&type=template&id=77e6cf5e&scoped=true&"
import script from "./PageSize.vue?vue&type=script&lang=js&"
export * from "./PageSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e6cf5e",
  null
  
)

export default component.exports